import { useInfiniteQuery } from 'react-query'
import { ArticleClient } from 'api/clients/ArticleClient'
import { getNextPageParam } from 'utils/getNextPageParam'
import { defaultLongCacheTime } from '../../queryClient'

export const useFoldersAndFiles = (workspaceId: number) => {
  return useInfiniteQuery(['workspaceId', workspaceId], ArticleClient.fetchFoldersAndFiles(workspaceId), {
    cacheTime: defaultLongCacheTime,
    refetchOnWindowFocus: false,
    getNextPageParam,
  })
}
